export const setZonesCategories = (zonesCategories = []) => ({
  type: 'SET_ZONES_CATEGORIES',
  payload: zonesCategories,
});
